export default __webpack_public_path__ + "static/media/ic_service_center_selected.8fad9321.svg";